import { useCoachMark } from '#hooks/useCoachMark';
import CoachMark from '#shared/CoachMark';
import { useEffect, useState } from 'react';

interface EmptyCoachMarkProps {}

const EmptyCoachMark = ({}: EmptyCoachMarkProps) => {
  const { isCoachMark } = useCoachMark();

  const [right, setRight] = useState(0);

  const getRight = () => {
    const offset = 20;

    const halfInnerWidth = window.innerWidth / 2;
    const halfMaxWidth = 500 / 2;

    if (window.innerWidth < 500) return offset;

    return halfInnerWidth - halfMaxWidth + offset;
  };

  useEffect(() => {
    setRight(getRight());

    window.addEventListener('resize', () => {
      setRight(getRight());
    });

    return () => {
      window.removeEventListener('resize', () => {
        setRight(getRight());
      });
    };
  }, [getRight]);

  if (!isCoachMark) return null;

  return (
    <CoachMark.SpotLight
      style={{
        position: 'fixed',
        right: `${right}px`,
        top: '335px',
        width: 'calc(100% - 60px)',
        maxWidth: 'calc(var(--max-width) - 60px)'
      }}
    >
      <CoachMark.Tooltip
        position="top"
        message={`빈 칸을 터치해도 일정을 추가할 수 있어요`}
      />
      <div className="w-full h-[72px] p-2 bg-[#17161b] rounded-xl flex-col justify-start items-start inline-flex">
        <div className="self-stretch w-full border-t border-solid border-[#252230] justify-start items-center inline-flex">
          <div className="flex-grow h-[33px] px-4 py-10 border-r border-solid border-[#373245]" />
          <div className="flex-grow h-[33px] px-4 py-10 border-r border-solid border-[#373245]" />
          <div className="flex-grow h-[33px] px-4 py-10 border-r border-solid border-[#373245]" />
          <div className="flex-grow h-[33px] px-4 py-10 border-r border-solid border-[#373245]" />
          <div className="flex-grow h-[33px] px-4 py-10 border-r border-solid border-[#373245]" />
          <div className="flex-grow h-[33px] px-4 py-10 border-r border-solid border-[#373245]" />
          <div className="flex-grow h-[33px] px-4 py-10" />
        </div>
        <div className="self-stretch w-full border-t border-solid border-[#373245] justify-start items-center inline-flex">
          <div className="flex-grow h-[33px] px-4 py-10 border-r border-solid border-[#373245]" />
          <div className="flex-grow h-[33px] px-4 py-10 border-r border-solid border-[#373245]" />
          <div className="flex-grow h-[33px] px-4 py-10 border-r border-solid border-[#373245]" />
          <div className="flex-grow h-[33px] px-4 py-10 border-r border-solid border-[#373245]" />
          <div className="flex-grow h-[33px] px-4 py-10 border-r border-solid border-[#373245]" />
          <div className="flex-grow h-[33px] px-4 py-10 border-r border-solid border-[#373245]" />
          <div className="flex-grow h-[33px] px-4 py-10" />
        </div>
      </div>
    </CoachMark.SpotLight>
  );
};

export default EmptyCoachMark;
